export type ContactDocumentTypeMessages = {
  rgOption: string;
  cpfOption: string;
  cnpjOption: string;
};

export const CONTACT_DOCUMENT_TYPE_MESSAGES: ContactDocumentTypeMessages = {
  rgOption: "Registro Geral (RG)",
  cpfOption: "CPF",
  cnpjOption: "CNPJ",
};
